/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_Invalid_RecurrenceInputs */

const vi_error_work_activity_invalid_recurrence = /** @type {(inputs: Error_Work_Activity_Invalid_RecurrenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểu lặp lại không hợp lệ. Chỉ chọn: không lặp, hàng tháng, hàng quý, hàng năm.`)
};

/**

* @param {Error_Work_Activity_Invalid_RecurrenceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_invalid_recurrence = /** @type {((inputs?: Error_Work_Activity_Invalid_RecurrenceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_Invalid_RecurrenceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_invalid_recurrence(inputs)
});